import React, { Component } from 'react'
import { Segment, Icon } from 'semantic-ui-react'

import '../../../node_modules/semantic-ui-css/components/icon.css'
import '../../../node_modules/semantic-ui-css/components/segment.css'

export default class Footer extends Component {
  render () {
    return (
      <Segment className='footer white' textAlign='center'>
        Made With <Icon name='heart' />
        By <a href='http://www.jambonsw.com/' className='white'>
          JamBon Software
        </a>
      </Segment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/gallery/components/FooterComponent.js